import { FlatButton } from 'bz-core-controls';
import AuthStore from 'bz-stores/lib/auth-store';
import { Challenge } from 'core/auth/2fa/challenge';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Dialog from 'tm3-core/controls/modal/core-dialog';

import { CircularProgress } from '@material-ui/core';
import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import ClickDialog from 'click-controls/controls/dialogs/base';
import { AuthApp } from 'core/auth/2fa/setup/AuthApp';
import { Passkey } from 'core/auth/2fa/setup/Passkey';
import { action } from 'mobx';
import { ResetMode, TwoFactorVerify, UserResetRequest } from 'tm3-core/api.dtos';
import { MfaState } from './mfa';

export interface IMfaSetupDialogProps {
  open: boolean;
  onRequestClose: () => void;
  mode: MfaState;
  onChange: (mode: MfaState) => void;
}

@observer
export class MfaSetupDialog extends Component<IMfaSetupDialogProps> {
  @action.bound
  async onPassMFA(code: string) {
    this.props.onChange(MfaState.Loading);
    const client = new JsonServiceClient();
    const res = await client.post(
      new TwoFactorVerify({
        code: code
      })
    );

    this.props.onChange(res.result ? MfaState.Setup : MfaState.Failed);
  }
  @action.bound
  async onSetupMfa() {
    this.props.onChange(MfaState.Loading);
    const client = new JsonServiceClient();

    const res = await client.post(
      new UserResetRequest({
        mode: ResetMode.MFA,
        id: AuthStore.user.id
      })
    );
    this.props.onChange(MfaState.Setup);
  }
  @action.bound
  async onSetupComplete() {
    await AuthStore.checkLoginState();
    this.props.onChange(MfaState.Changed);
  }

  render() {
    const { open, onRequestClose, mode } = this.props;
    const content = (
      <>
        <div className="text-center text-lg font-bold">
          {mode === MfaState.SetupPassKey || mode === MfaState.PasskeyFailed
            ? 'Pass key setup'
            : MfaState.Setup
              ? 'Please Verify your MFA Details'
              : 'Setup Multi factor Authentication'}
        </div>
        {mode === MfaState.Initial && (
          <div className="login-areas">
            <Challenge showTitle={false} showTrust={false} onPass={this.onPassMFA} />
          </div>
        )}
        {mode == MfaState.Loading && <CircularProgress />}
        {mode === MfaState.Setup && (
          <div className="login-areas ">
            <AuthApp onSetupComplete={this.onSetupComplete} />
          </div>
        )}

        {mode === MfaState.Changed && <p>You have setup MFA on your account.</p>}
        {mode === MfaState.Failed && (
          <p>
            There was a problem changing your MFA details, please contact your System Administrator.
          </p>
        )}
        {mode === MfaState.PasskeyFailed && (
          <p>There was a problem adding a Passkey, please contact your System Administrator.</p>
        )}
        {mode === MfaState.SetupPassKey && (
          <Passkey
            onSetupComplete={() => this.props.onChange(MfaState.SetupPassKeyComplete)}
            onError={() => this.props.onChange(MfaState.PasskeyFailed)}
          />
        )}
        {mode === MfaState.SetupPassKeyComplete && <p>You have setup an additional pass key.</p>}
        <div className="mt-4 grid items-center">
          <FlatButton onClick={onRequestClose}>Close</FlatButton>
        </div>
      </>
    );
    if (process.env.isClick)
      return (
        <ClickDialog
          isOpen={open}
          onClose={onRequestClose}
          displayFooter={false}
          overlayClassName="!w-[600px]"
        >
          {content}
        </ClickDialog>
      );
    else return <Dialog open={open}>{content}</Dialog>;
  }
}
